<!-- Copyright (c) 2024 VMware, Inc. All rights reserved. VMware Confidential -->
<clr-combobox-container>
    <clr-combobox (clrOpenChange)="onOpenChange($event)"
                  (clrSelectionChange)="onSelectionChange($event)"
                  [(ngModel)]="selectedItem"
                  #combobox
                  name="subType"
                  required>
        <clr-options>
            <clr-option *clrOptionItems="let item of items; field: 'label'"
                        [clrValue]="item">
                {{ item.label }}
            </clr-option>
        </clr-options>
    </clr-combobox>
</clr-combobox-container>
